import React, { Component } from 'react'
import AllFloorsCard from './dashboardComponents/floorManager/AllFloorsCard'
import StatsFloorCard from './dashboardComponents/projectStats/floorStats/StatsFloorCard'
import StatsTagCard from './dashboardComponents/projectStats/tagStats/StatsTagCard'
import AboutProjectCard from './dashboardComponents/settings/AboutProjectCard'
import QrCodeCard from './dashboardComponents/settings/QrCodeCard'
import AllTagsCard from './dashboardComponents/tagManager/AllTagsCard'
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import { get } from 'lodash'
import DashboardLock from '../widgets/DashboardLock'
import AllProjectLimitStats from './dashboardComponents/projectStats/allLimitStats/AllProjectLimitStats'
class MinimalProjectProfile extends Component {
    render() {
        const { projectProductOrder, themeColors, snagDetail, alu, userData } = this.props;
        const { limitTrackerProjectDashboardAccess } = alu;

        if (snagDetail && projectProductOrder) {

            const { uid, employeeid } = userData;
            const { accessMap } = snagDetail;
            var ueid = uid + employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;

            const { tagCount, tagLimit, internalProjectMembersLimit, externalProjectMembersLimit, projectTagLimit } = projectProductOrder;
            const { totalActiveExternalMember, totalActiveInternalMember, projectTagCount } = snagDetail;

            const tagLimitReached = tagCount > tagLimit ? true : false;
            const internalProjectMembersLimitReached = internalProjectMembersLimit === "-1" ? false : totalActiveInternalMember > internalProjectMembersLimit ? true : false;
            const externalProjectMembersLimitReached = externalProjectMembersLimit === "-1" ? false : totalActiveExternalMember > externalProjectMembersLimit ? true : false;
            const projectTagLimitReached = projectTagLimit === "-1" ? false : projectTagCount > projectTagLimit ? true : false;
            if (projectTagLimitReached) {
                return (
                    <React.Fragment>
                        <DashboardLock isProjectTagLimitReached={true} />
                    </React.Fragment>
                );
            }
            if (tagLimitReached || internalProjectMembersLimitReached || externalProjectMembersLimitReached) {
                return (
                    <div className="container-fluid py-3">
                        <div className="card-deck mb-2 px-2">
                            <AboutProjectCard />
                            <AllFloorsCard tagLimitReached={tagLimitReached} internalProjectMembersLimitReached={internalProjectMembersLimitReached}
                                externalProjectMembersLimitReached={externalProjectMembersLimitReached} />
                            <StatsFloorCard />

                        </div>
                        <div className="card-deck mb-2 px-2">
                            <QrCodeCard />
                            <AllTagsCard />
                            <StatsTagCard />
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className="container-fluid py-3">
                        <div className="card-deck mb-2 px-2">
                            <AboutProjectCard />
                            <AllFloorsCard />
                           {limitTrackerProjectDashboardAccess[accessLevel] ? <StatsFloorCard />:<StatsTagCard />}
                        </div>

                        <div className="card-deck mb-2 px-2">
                            <QrCodeCard />
                            <AllTagsCard />
                           {limitTrackerProjectDashboardAccess[accessLevel] ? <StatsTagCard />: <div className="card p-2 " style={{ borderRadius: '15px', border: 'none', backgroundColor: 'transparent' }} ></div>}
                        </div>
                        <div className="card-deck mb-2 px-2">
                            {limitTrackerProjectDashboardAccess[accessLevel] ? <AllProjectLimitStats tagCount={tagCount} tagLimit={tagLimit} internalProjectMembersLimit={internalProjectMembersLimit} externalProjectMembersLimit={externalProjectMembersLimit}
                                totalActiveInternalMember={totalActiveInternalMember} totalActiveExternalMember={totalActiveExternalMember}
                                projectTagLimit={projectTagLimit}
                                projectTagCount={projectTagCount} isInternalMember={true} /> : <React.Fragment />}
                            <div className="card p-2 " style={{ borderRadius: '15px', border: 'none', backgroundColor: 'transparent' }} ></div>
                            <div className="card p-2 " style={{ borderRadius: '15px', border: 'none', backgroundColor: 'transparent' }} ></div>
                        </div>
                    </div>
                )
            }

        }
        else {
            return (
                <div className="container-fluid">
                    <div className="" >
                        <div className="card p-3 pt-5">
                            <Loader
                                type="TailSpin"
                                color={themeColors.themeColor}
                                height={50}
                                width={50}
                            />
                            {/* <br></br>
                            <p style={textStyle}>Loading your company...</p>
                            <br></br> */}
                        </div>
                    </div>
                </div>
            )
        }


    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        projectProductOrder: state.firestore.data.ProjectProductOrder,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        alu: state.alu,
        userData: state.firebase.profile,
    }
}

export default connect(mapStateToProps)(MinimalProjectProfile)

